'use client';

import { cn, tv } from '@app/ui/_lib/utils';
import { Container } from '../Container';
import { ContactHeader, ContactHeaderProps } from '../ContactHeader';
import { Location, LocationProps } from '../Location';
import { Text } from '../Text';
import { FormBlock, FormBlockProps } from '../FormBlock';

const styles = tv({
	slots: {
		card: 'rounded-lg bg-card-background-primary p-spacing-md lg:p-spacing-2xl',
	},
});

export type ContactGridProps = {
	className?: string;
	formHeader?: Omit<ContactHeaderProps, 'className'>;
	form?: Omit<FormBlockProps, 'className'> & { formTitle?: string };
	locationsHeader?: Omit<ContactHeaderProps, 'className'>;
	locations?: {
		label?: string;
		title?: string;
		items?: Omit<LocationProps, 'className'>[];
	};
};

export function ContactGrid(props: ContactGridProps) {
	const { card } = styles();
	const hasSecondColumn =
		(props.locations?.items && props.locations.items.length > 0) ||
		(props.locations &&
			JSON.stringify(props.locations) !== '{}' &&
			props.locationsHeader &&
			JSON.stringify(props.locationsHeader) !== '{}');

	return (
		<section className={props.className} data-component='ContactGrid'>
			<Container
				className={cn('no-nested-containers', hasSecondColumn && 'grid gap-spacing-lg lg:grid-cols-2')}
				size={!hasSecondColumn ? 'md' : 'default'}
			>
				<div className={card({ className: 'flex flex-col gap-spacing-lg' })}>
					{props.formHeader && (
						// don't do this
						// && JSON.stringify(props.formHeader) !== '{}'
						<>
							<ContactHeader {...props.formHeader} />

							<div className='bg-border-primary h-px w-full' />
						</>
					)}

					{props.form && (
						<div>
							{props.form.formTitle && (
								<Text as='h3' className='mb-8' styleType='body-xl-medium'>
									{props.form.formTitle}
								</Text>
							)}

							<FormBlock {...props.form} />
						</div>
					)}
				</div>

				{hasSecondColumn && (
					<div className='flex flex-col gap-spacing-lg'>
						{props.locationsHeader && (
							<div className={card()}>
								<ContactHeader {...props.locationsHeader} />
							</div>
						)}

						{props.locations?.items && props.locations.items.length > 0 && (
							<div className={card()}>
								{(props.locations.label || props.locations.title) && (
									<div className='flex flex-col gap-spacing-2xs sm:mb-spacing-lg'>
										{props.locations.label && (
											<Text className='text-text-brand' styleType='label-md'>
												{props.locations.label}
											</Text>
										)}

										{props.locations.title && (
											<Text as='h2' styleType='heading-sm'>
												{props.locations.title}
											</Text>
										)}
									</div>
								)}

								{props.locations.items.map((item, i) => (
									<Location key={i} {...item} className='border-b border-border-primary' />
								))}
							</div>
						)}
					</div>
				)}
			</Container>
		</section>
	);
}
